<template>
  <el-dialog
    :title="$t('mainCategoryProduct.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div class="text-center">
      <p>{{$t('mainCategoryProduct.confirmDeleteProduct')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('mainCategoryProduct.cancel')}}</el-button>
      <el-button type="primary" @click="confirmDelete">{{$t('mainCategoryProduct.confirmDelete')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMainCategoryProduct } from '@/api/admin/mainCategoryProduct/mainCategoryProductApi'

export default {
  name: 'DeleteMainCategoryProduct',
  data() {
    return {
      dialogVisible: false,
      deleteData: {}
    }
  },
  methods: {
    open(data) {
      this.deleteData = Object.assign({}, data)
      this.dialogVisible = true
    },
    async confirmDelete() {
      try {
        await deleteMainCategoryProduct(this.deleteData)
        this.$message.success(this.$t('mainCategoryProduct.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
      }
    },
    handleClose() {
      this.deleteData = {}
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>